module.exports = __webpack_public_path__ + "fonts/TiemposTextWeb-Bold.eot";